import { NonIdealState, Spinner } from '@blueprintjs/core'
import React, { Component } from 'react'
import { connect, MapStateToProps } from 'react-redux'
import { Redirect } from 'react-router'

import { DispatchProp } from 'modules/store'

import { links } from '../../app.links'
import * as fromAuthStore from '../store'

type Props = DispatchProp & StateProps
type StateProps = {
  loggingOut: boolean
}

const mapStateToProps: MapStateToProps<StateProps, {}, fromAuthStore.AuthState> = (state: fromAuthStore.AuthState) => ({
  loggingOut: fromAuthStore.getIsLoggingOut(state),
})
const enhance = connect(mapStateToProps)
class Logout extends Component<Props> {
  componentWillMount() {
    this.props.dispatch(new fromAuthStore.actions.LogoutAction())
  }
  render() {
    const { loggingOut } = this.props

    if (loggingOut) {
      return (
        <NonIdealState title="Please wait...">
          <Spinner />
        </NonIdealState>
      )
    }

    return !loggingOut && <Redirect to={links.auth.home()} />
  }
}

export default enhance(Logout)



// WEBPACK FOOTER //
// ./src/app/auth/components/logout.tsx